/** @jsx jsx */
import { Link } from 'gatsby'
import { Box, Heading, Text, jsx } from 'theme-ui'

const FooterLinksSection = ({ title, pages }) => {
  return (
    <Box
      as="nav"
      role="navigation"
      aria-label={`Footer ${title} navigation`}
      mb={[5, null, 6, 7]}
      sx={{ '&:last-of-type': { mb: [null, null, null, 0] } }}
    >
      <Heading as="h2" variant="title5" mb={2}>
        {title}
      </Heading>
      <Box as="ul" m={0} p={0} sx={{ listStyleType: 'none' }}>
        {pages.map((page, i) => {
          const {
            footerNavTitle,
            name,
            path,
            slug,
            slugUrl,
            title,
            url,
            __typename,
          } = page
          let to = path || slug

          if (__typename === 'ContentfulLandingPage') {
            to = `try/${slug}`
          }

          if (__typename === 'ContentfulPack') {
            to = `products/${slugUrl || slug}`
          }

          return (
            <Box
              as="li"
              m={0}
              p={0}
              sx={{ listStyleType: 'none' }}
              key={`footer-link-${i}`}
            >
              <Text
                as="p"
                variant="body3"
                sx={{
                  a: {
                    variant: 'text.footerLink',
                    display: 'inline-block',
                    py: [1, '4px'],
                  },
                }}
              >
                <FooterLinksLink
                  title={footerNavTitle || name || title}
                  ariaLabel={`${footerNavTitle || name || title} (${name})`}
                  to={to || url}
                  __typename={__typename}
                />
              </Text>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

const FooterLinksLink = ({ title, to, ariaLabel, __typename }) => {
  if (__typename === 'ContentfulNavigationExternalLink') {
    return (
      <a
        href={to}
        rel="noreferrer"
        target="_blank"
        title={`${title} (opens in a new window)`}
      >
        {title}
      </a>
    )
  }

  return (
    <Link to={`/${to}/`} aria-label={ariaLabel}>
      {title}
    </Link>
  )
}

export default FooterLinksSection
